import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import shipOrderApi, { ShipOrderData } from '../apis/shipOrder.api'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ContentAside from '../components/ContentAside'
import ShipOrderTable from '../partials/ShipOrderTable'
import ShipOrderItems from '../partials/ShipOrderItems'

interface ShipOrderRouteState {
  id: number
}

interface ShipOrderProps
  extends RouteComponentProps<any, any, ShipOrderRouteState> {}

interface ShipOrderState {
  shipOrder: ShipOrderData | null
}

class ShipOrder extends Component<ShipOrderProps, ShipOrderState> {
  constructor (props: ShipOrderProps) {
    super(props)
    this.state = {
      shipOrder: null
    }
    this.handleEditClick = this.handleEditClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  get items () {
    const { shipOrder } = this.state
    return shipOrder && shipOrder.items &&
      <ShipOrderItems items={shipOrder.items} />
  }

  handleEditClick () {
    const pathname = routes.shipOrderEdit
    const state = { id: this.id }
    this.props.history.push({ pathname, state })
  }

  readShipOrder () {
    shipOrderApi.read(this.id, shipOrder => {
      if (!shipOrder) return
      this.setState({ shipOrder })
    })
  }

  componentDidMount () {
    this.readShipOrder()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="half">
          <ShipOrderTable
            shipOrder={this.state.shipOrder}
            onEditClick={this.handleEditClick} />
        </ContentMain>
        <ContentAside layout="half">
          {this.items}
        </ContentAside>
      </ContentLayout>
    )
  }
}

export default withRouter(ShipOrder)
